var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInactiveQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C49.8 30 69.6 30 90 30 C90 79.5 90 129 90 180 C40.5 180 -9 180 -60 180 C-60 160.2 -60 140.4 -60 120 C-69.9 120 -79.8 120 -90 120 C-90 110.1 -90 100.2 -90 90 C-80.1 90 -70.2 90 -60 90 C-60 80.1 -60 70.2 -60 60 C-69.9 60 -79.8 60 -90 60 C-90 50.1 -90 40.2 -90 30 C-60.3 30 -30.6 30 0 30 C0 20.1 0 10.2 0 0 Z M-30 60 C-30 89.7 -30 119.4 -30 150 C-0.3 150 29.4 150 60 150 C60 120.3 60 90.6 60 60 C30.3 60 0.6 60 -30 60 Z ",
    fill: "grey",
    transform: "translate(361,270)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C49.5 0 99 0 150 0 C150 9.9 150 19.8 150 30 C130.2 30 110.4 30 90 30 C90 59.7 90 89.4 90 120 C99.9 120 109.8 120 120 120 C120 129.9 120 139.8 120 150 C110.1 150 100.2 150 90 150 C90 159.9 90 169.8 90 180 C109.8 180 129.6 180 150 180 C150 170.1 150 160.2 150 150 C159.9 150 169.8 150 180 150 C180 159.9 180 169.8 180 180 C189.9 180 199.8 180 210 180 C210 189.9 210 199.8 210 210 C160.5 210 111 210 60 210 C60 200.1 60 190.2 60 180 C50.1 180 40.2 180 30 180 C30 170.1 30 160.2 30 150 C39.9 150 49.8 150 60 150 C60 130.2 60 110.4 60 90 C50.1 90 40.2 90 30 90 C30 80.1 30 70.2 30 60 C39.9 60 49.8 60 60 60 C60 50.1 60 40.2 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(61,240)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C49.5 0 99 0 150 0 C150 49.5 150 99 150 150 C130.2 150 110.4 150 90 150 C90 159.9 90 169.8 90 180 C80.1 180 70.2 180 60 180 C60 170.1 60 160.2 60 150 C40.2 150 20.4 150 0 150 C0 100.5 0 51 0 0 Z M30 30 C30 59.7 30 89.4 30 120 C59.7 120 89.4 120 120 120 C120 90.3 120 60.6 120 30 C90.3 30 60.6 30 30 30 Z ",
    fill: "grey",
    transform: "translate(301,60)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C49.5 0 99 0 150 0 C150 9.9 150 19.8 150 30 C159.9 30 169.8 30 180 30 C180 39.9 180 49.8 180 60 C170.1 60 160.2 60 150 60 C150 89.7 150 119.4 150 150 C100.5 150 51 150 0 150 C0 100.5 0 51 0 0 Z M30 30 C30 59.7 30 89.4 30 120 C59.7 120 89.4 120 120 120 C120 90.3 120 60.6 120 30 C90.3 30 60.6 30 30 30 Z ",
    fill: "grey",
    transform: "translate(61,60)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 39.6 30 79.2 30 120 C-9.6 120 -49.2 120 -90 120 C-90 110.1 -90 100.2 -90 90 C-60.3 90 -30.6 90 0 90 C0 60.3 0 30.6 0 0 Z ",
    fill: "grey",
    transform: "translate(482,392)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 29.7 30 59.4 30 90 C59.7 90 89.4 90 120 90 C120 99.9 120 109.8 120 120 C80.4 120 40.8 120 0 120 C0 80.4 0 40.8 0 0 Z ",
    fill: "grey",
    transform: "translate(0,392)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 39.6 120 79.2 120 120 C110.1 120 100.2 120 90 120 C90 90.3 90 60.6 90 30 C60.3 30 30.6 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(392,0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C39.6 0 79.2 0 120 0 C120 9.9 120 19.8 120 30 C90.3 30 60.6 30 30 30 C30 59.7 30 89.4 30 120 C20.1 120 10.2 120 0 120 C0 80.4 0 40.8 0 0 Z ",
    fill: "grey",
    transform: "translate(0,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C59.7 30 89.4 30 120 30 C120 39.9 120 49.8 120 60 C80.4 60 40.8 60 0 60 C0 40.2 0 20.4 0 0 Z ",
    fill: "grey",
    transform: "translate(241,210)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 19.8 30 39.6 30 60 C20.1 60 10.2 60 0 60 C0 40.2 0 20.4 0 0 Z ",
    fill: "grey",
    transform: "translate(61,330)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 19.8 30 39.6 30 60 C20.1 60 10.2 60 0 60 C0 40.2 0 20.4 0 0 Z ",
    fill: "grey",
    transform: "translate(181,300)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C19.8 0 39.6 0 60 0 C60 9.9 60 19.8 60 30 C40.2 30 20.4 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(391,240)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 19.8 30 39.6 30 60 C20.1 60 10.2 60 0 60 C0 40.2 0 20.4 0 0 Z ",
    fill: "grey",
    transform: "translate(241,120)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(61,420)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(361,360)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(241,330)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(211,270)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(361,120)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(121,120)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 9.9 30 19.8 30 30 C20.1 30 10.2 30 0 30 C0 20.1 0 10.2 0 0 Z ",
    fill: "grey",
    transform: "translate(241,60)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveQrCode);
export default __webpack_public_path__ + "static/media/inactive-qr-code.355be9f791831e8997dc585744ae88c6.svg";
export { ForwardRef as ReactComponent };